module.exports = __webpack_public_path__ + "img/logo.png?78e518da297d70f0de27f90d04f59f7a";